import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import rules from '../../containers/shared/auth/rules';
import { AuthConsumer } from '../../containers/shared/auth/AuthContext';
import { useRouter } from '../../hooks';
import { getUserRole } from '../../containers/shared/auth/rules';
import { User } from 'react-feather';
import { Online } from '../../hooks/useOnlineStatus';
import { getUserDataOrganisations } from '../../utils/idbFns';

type OrganisationType = {
  id: string;
  name: string;
  type: string;
};

type UserOrganisationType = {
  id: string;
  isDefault: boolean;
  role: {
    name: string;
  };
  organisation: {
    id: string;
    serviceProvider?: {
      name: string;
    } | null;
    funder?: {
      name: string;
    } | null;
    institution?: {
      name: string;
    } | null;
  };
};

const Main = styled('div')`
  font-family: sans-serif;
`;

const DropDownContainer = styled('div')``;

const DropDownHeader = styled('div')`
  margin-right: 10px;
  font-size: 1rem;
  color: white;
  &:hover {
    cursor: pointer;
  }
`;

const DropDownListContainer = styled('div')`
  margin-right: 20px;
  position: absolute;
  z-index: 10000;
  background-color: #3d484a;
  padding-left: 10px;
  padding-right: 10px;
  width: 200px;
  left: 85%;
`;

const DropDownList = styled('ul')`
  padding: 0;
  margin: 0;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  &:first-child {
    padding-top: 0.8em;
  }
  left: 150px;
`;

const ListItem = styled(NavLink)`
  list-style: none;
  margin-bottom: 1em;
  margin-top: 1em;
  &:hover {
    cursor: pointer;
  }
  color: white;
  font-size: 1rem;
  font-weight: 500;
  display: flex;
  text-decoration: none;
`;

//(accessRoutes: string[]) => { route: string; name: string; type: string }[]

type FormOrganisationOrganisationType = {
  id: string;
  name: string;
  type: string;
};

type FormOrganisationType = {
  id: string;
  isDefault: boolean;
  role: string;
  organisation: FormOrganisationOrganisationType;
};

export const formOrganisation = (obj: UserOrganisationType): FormOrganisationType | undefined => {
  if (obj.organisation) {
    return {
      id: obj.id,
      isDefault: obj.isDefault || false,
      role: obj.role && obj.role.name,
      organisation: {
        id: obj.organisation.id,
        name: obj.organisation.funder
          ? obj.organisation.funder.name
          : obj.organisation.serviceProvider
          ? obj.organisation.serviceProvider.name
          : obj.organisation.institution
          ? obj.organisation.institution.name
          : '',
        type: obj.organisation.funder
          ? 'funder'
          : obj.organisation.serviceProvider
          ? 'serviceProvider'
          : obj.organisation.institution
          ? 'institution'
          : '',
      },
    };
  } else {
    return undefined;
  }
};

const getAdminOptions = (
  accessRoutes: string[],
  organisations: { organisation: { id: string; type: string; name: string } }[],
  url: string,
  currOrganisationId: string
): { route: string; name: string; organisationId: string; selected: boolean | undefined }[] => {
  let returnArray = [];

  if (accessRoutes.includes('/admin:visit')) {
    var orgId = organisations.length > 0 ? organisations[0].organisation.id : '';
    returnArray.push({
      route: '/admin',
      name: 'Admin',
      organisationId: orgId,
      selected: url.startsWith('/admin'),
    });
  }

  if (accessRoutes.includes('/service-provider:visit')) {
    const orgs = organisations.filter((x: any) => x.organisation.type === 'serviceProvider');

    if (orgs) {
      orgs.forEach((org: any) => {
        returnArray.push({
          route: '/service-provider',
          name: org ? org.organisation.name : '',
          organisationId: org ? org.organisation.id : '',
          selected: org && !url.startsWith('/admin') && org.organisation.id === currOrganisationId,
        });
      });
    }
  }

  if (accessRoutes.includes('/institution:visit')) {
    const orgs = organisations.filter((x: any) => x.organisation.type === 'institution');

    if (orgs) {
      orgs.forEach((org: any) => {
        returnArray.push({
          route: '/institution',
          name: org ? org.organisation.name : '',
          organisationId: org ? org.organisation.id : '',
          selected: org && !url.startsWith('/admin') && org.organisation.id === currOrganisationId,
        });
      });
    }
  }

  if (accessRoutes.includes('/funder:visit')) {
    const orgs = organisations.filter((x: any) => x.organisation.type === 'funder');
    if (orgs) {
      orgs.forEach((org: any) => {
        returnArray.push({
          route: '/funder',
          name: org ? org.organisation.name : '',
          organisationId: org ? org.organisation.id : '',
          selected: org && !url.startsWith('/admin') && org.organisation.id === currOrganisationId,
        });
      });
    }
  }

  return returnArray;
};

const getOptions = (
  organisations: OrganisationType[],
  currentOrganisationid: string
): { route: string; name: string; organisationId: string; selected: boolean }[] => {
  let returnArray: { route: string; name: string; organisationId: string; selected: boolean }[] = [];
  organisations.map(obj => {
    const selected = obj.id === currentOrganisationid;
    if (obj.type === 'serviceProvider') {
      returnArray.push({ route: '/service-provider', name: obj.name, organisationId: obj.id, selected: selected });
    }
    if (obj.type === 'funder') {
      returnArray.push({ route: '/funder', name: obj.name, organisationId: obj.id, selected: selected });
    }
    if (obj.type === 'institution') {
      returnArray.push({ route: '/institution', name: obj.name, organisationId: obj.id, selected: selected });
    }
  });

  return returnArray;
};

export const PortalDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);
  const container = useRef<HTMLDivElement>(null);
  const toggling = (e: any) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  };
  const { match } = useRouter();
  const [adminUserOrganisations, setAdminUserOrganisations] = useState<FormOrganisationType[]>([]);
  const [userOrganisations, setUserOrganisations] = useState<FormOrganisationOrganisationType[]>([]);

  const url = () => {
    const path = match.url;
    if (path.startsWith('/service-provider')) {
      return '/service-provider';
    }
    if (path.startsWith('/funder')) {
      return '/funder';
    }
    if (path.startsWith('/institution')) {
      return '/institution';
    }
    return '/admin';
  };

  useEffect(() => {
    const handleClickOutsidePortalDropdown = (event: any) => {
      if (isOpen && !(container.current && container.current.contains(event.target))) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutsidePortalDropdown);

    return () => {
      document.removeEventListener('click', handleClickOutsidePortalDropdown);
    };
  }, [isOpen]);

  useEffect(() => {
    (async () => {
      const organisations = await getUserDataOrganisations();
      const adminUserOrganisations = organisations
        .map(x => formOrganisation(x))
        .filter(x => !!x) as FormOrganisationType[];
      const userOrganisations = adminUserOrganisations.map(a => a && a.organisation);
      setAdminUserOrganisations(adminUserOrganisations);
      setUserOrganisations(userOrganisations);
    })();
  }, []);

  return (
    <AuthConsumer>
      {authContext => {
        const currentUser = authContext.user;
        const userRoles = currentUser.roles;
        const userPlan = currentUser.plan;

        const ruleSet = {
          static: [] as string[],
        };

        userRoles.forEach(role => {
          ruleSet.static = rules[role][userPlan]
            ? ruleSet.static.concat(rules[role][userPlan].static)
            : ruleSet.static.concat(rules[role].static);
        });
        const routesList = ruleSet.static;
        const isAdmin = ['ADMIN', 'SUPERADMIN'].some(role => currentUser.roles.includes(getUserRole(role)));

        const currOrganisationId = currentUser.userOrganisation ? currentUser.userOrganisation.organisation.id : '';
        const options = isAdmin
          ? // @ts-ignore
            getAdminOptions(routesList, adminUserOrganisations, match.url, currOrganisationId)
          : // @ts-ignore
            getOptions(userOrganisations, currOrganisationId);

        const { logout } = authContext;

        return (
          <Main>
            <DropDownContainer>
              <DropDownHeader onClick={toggling}>
                <User />
              </DropDownHeader>
              {isOpen && (
                <DropDownListContainer ref={container}>
                  <DropDownList>
                    {options &&
                      options.length > 1 &&
                      options
                        .filter((option: any) => option.name)
                        .map((option: any, index: any) => (
                          <Online key={`portal-${index}`} showIfOffline={option.selected}>
                            <ListItem
                              key={`portal-${index}`}
                              to={option.route}
                              style={{
                                ...(option.name !== 'Admin' && {
                                  textTransform: 'uppercase',
                                }),
                                ...(option.selected && { textDecorationLine: 'underline' }),
                              }}
                              onClick={async e => {
                                e.preventDefault();
                                if (!option.selected) {
                                  await authContext.setActiveOrganisation(option.route, option.organisationId, () => {
                                    setIsOpen(false);
                                  });
                                } else {
                                  setIsOpen(false);
                                }
                              }}
                            >
                              {option.name}
                              <br />
                            </ListItem>
                          </Online>
                        ))}
                    <ListItem to={`${url()}/my-profile`}>
                      My Profile
                      <br />
                    </ListItem>
                    <ListItem
                      onClick={e => {
                        e.preventDefault();
                        logout();
                      }}
                      to="/"
                    >
                      Log out
                      <br />
                    </ListItem>
                  </DropDownList>
                </DropDownListContainer>
              )}
            </DropDownContainer>
          </Main>
        );
      }}
    </AuthConsumer>
  );
};
